import { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Logo from "../../components/Logo";
import OtpInput from "../../components/OtpInput";
import { useAuth } from "../../store/authEtablissementStore";

const PENDING_EMAIL_KEY = "agbaza.login.pendingEmail";

export default function EtablissementLoginCode() {
  const navigate = useNavigate();
  const location = useLocation();
  const { confirmLoginOtp } = useAuth();
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const state = location.state as { email?: string; redirect?: string } | null;
  const redirectTo = state?.redirect;

  useEffect(() => {
    const fromState = state?.email;
    const fromStorage = sessionStorage.getItem(PENDING_EMAIL_KEY);
    const resolved = fromState ?? fromStorage ?? "";
    if (resolved) {
      setEmail(resolved);
      if (!fromStorage && fromState) {
        sessionStorage.setItem(PENDING_EMAIL_KEY, fromState);
      }
    } else {
      navigate("/etablissement/connexion", { replace: true });
    }
  }, [navigate, state?.email]);

  const codeValue = code.replace(/\s/g, "");
  const ready = codeValue.length === 6 && !!email && !submitting;

  const onConfirm = async () => {
    if (!ready || !email) return;
    setError("");
    setSubmitting(true);
    const result = await confirmLoginOtp(email, codeValue);
    setSubmitting(false);
    if (result.ok) {
      sessionStorage.removeItem(PENDING_EMAIL_KEY);
      const target =
        redirectTo && redirectTo.startsWith("/etablissement/")
          ? redirectTo
          : "/etablissement/dashboard/lits";
      navigate(target, { replace: true });
    } else {
      setError(result.message || "Code invalide ou expiré.");
    }
  };

  const onBack = () => {
    sessionStorage.removeItem(PENDING_EMAIL_KEY);
  };

  if (!email) return null;

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2 relative">
      <div className="absolute inset-0 md:hidden">
        <img src={'/maps-login-side.jpg'} alt="code" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-white/30" />
      </div>

      <div className="relative flex items-center justify-center px-4 md:px-10 py-10">
        <div className="w-full max-w-md">
          <div className="flex justify-center"><Logo size={56} /></div>
          <h1 className="mt-6 text-2xl md:text-3xl font-semibold text-[#0B1F16]">
            Code de connexion
          </h1>
          <p className="mt-2 text-sm text-gray-600">
            Un code à 6 chiffres a été envoyé à <b>{email}</b>.
          </p>

          {error && (
            <div className="mt-4 text-sm text-red-600 bg-red-50 border border-red-200 rounded-[10px] px-3 py-2">
              {error}
            </div>
          )}

          <div className="mt-6">
            <OtpInput value={code} onChange={setCode} length={6} />
          </div>

          <div className="mt-6 space-y-3">
            <button
              type="button"
              className="w-full h-12 rounded-[10px] font-semibold cursor-pointer disabled:opacity-60"
              style={{ backgroundColor: ready ? "#00553E" : "#DCEFE9", color: ready ? "#FFFFFF" : "#7aa79a" }}
              disabled={!ready}
              onClick={onConfirm}
            >
              {submitting ? "Vérification…" : "Confirmer"}
            </button>
            <Link to="/etablissement/connexion" className="block" onClick={onBack}>
              <button
                type="button"
                className="w-full h-12 rounded-[10px] font-semibold border cursor-pointer"
                style={{ borderColor: "#D1E2DD", color: "#00553E" }}
              >
                Retour
              </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="relative hidden md:block">
        <img src={'/maps-login-side.jpg'} alt="code" className="absolute inset-0 w-full h-full object-cover" />
      </div>
    </div>
  );
}
